import styled from 'styled-components'
import { colors, spacing } from 'styles'

export const Item = styled.div<{ isOpen: boolean }>`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0.5rem 0.9rem 0.25rem;
  cursor: pointer;
  overflow: hidden;
  transition: max-height 0.3s ease;
  max-height: ${(props) => (props.isOpen ? '200px' : '40px')};
  min-height: 40px;

  ul {
    list-style: none;
  }

  div + span svg {
    transition: transform 0.3s ease;
    transform: ${(props) => (props.isOpen ? 'rotate(-180deg)' : 'rotate(0)')};
  }

  span + ul {
    transition: opacity 0.3s ease;
    pointer-events: ${(props) => (props.isOpen ? 'default' : 'none')};
    opacity: ${(props) => (props.isOpen ? 1 : 0)};
  }
`

export const Name = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${spacing.stack.nano};

  i {
    font-size: 0.85rem;
    color: ${colors.content.subdued};
  }

  div + i {
    font-size: 0.75rem;
  }
`
